import { getRequest } from './api';

export const contractService = {
  // Get contracts by service request ID
  getContractsByRequestId: async (requestId) => {
    try {
      const filter = {
        where: { serviceRequestId: requestId },
        include: [{ relation: 'serviceRequest' }],
      };

      const response = await getRequest(`contracts?filter=${JSON.stringify(filter)}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get contract differences (customer vs partner contracts)
  getContractDifferences: async () => {
    try {
      // Get all contracts and group by serviceRequestId
      const contracts = await getRequest('contracts');

      // Group contracts by serviceRequestId
      const groupedContracts = {};

      contracts.forEach(contract => {
        const requestId = contract.serviceRequestId;
        if (!groupedContracts[requestId]) {
          groupedContracts[requestId] = {
            customer: null,
            partner: null,
          };
        }

        if (contract.createdBy === 'customer') {
          groupedContracts[requestId].customer = contract;
        } else if (contract.createdBy === 'partner') {
          groupedContracts[requestId].partner = contract;
        }
      });

      // Filter only requests that have both customer and partner contracts
      const differences = Object.entries(groupedContracts)
        .filter(([_, contracts]) => contracts.customer && contracts.partner)
        .map(([requestId, contracts]) => ({
          requestId,
          customerContract: contracts.customer,
          partnerContract: contracts.partner,
        }));

      return differences;
    } catch (error) {
      throw error;
    }
  },

  // Get single contract
  getContractById: async (contractId) => {
    try {
      const response = await getRequest(`contracts/${contractId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default contractService;
